import moment from 'moment-timezone';

import { useCallback } from 'react';
import { useAdvertiserContext } from '../Contexts/AdvertiserContext';
import { useAgencyContext } from '../Contexts/AgencyContext';
import { useHatDashboardPageContext } from '../Pages/HatDashboardPage';

const useHatExport = () => {
    const agency = useAgencyContext();
    const { advertiserContext } = useAdvertiserContext();
    const { dealer: advertiser } = advertiserContext;

    const { hatCriteria } = useHatDashboardPageContext();

    const generateExportFilename = useCallback(
        async (format = '{id}'): Promise<string> => {
            let keywords: string[] = [];

            if (agency) {
                keywords.push(agency.name);
            }

            if (advertiser) {
                keywords.push(advertiser.dealerName);
            }

            if (hatCriteria) {
                if (hatCriteria.startDate) {
                    keywords.push(moment(hatCriteria.startDate).format('YYYYMMDD'));
                }

                if (hatCriteria.endDate) {
                    keywords.push(moment(hatCriteria.endDate).format('YYYYMMDD'));
                }
            }

            return format.replace('{id}', keywords.join(' - '));
        },
        [agency, advertiser, hatCriteria]
    );

    return {
        generateExportFilename,
    };
};

export { useHatExport };
